import { Check } from "lucide-react";

const PRESETS = ["#C2410C", "#1D4ED8", "#047857", "#0F172A", "#B91C1C", "#7C2D12"];

export const BrandColorPicker = ({ value, onChange }) => (
  <div className="flex flex-wrap items-center gap-2" data-testid="settings-brand-color">
    {PRESETS.map((c) => (
      <button key={c} type="button" onClick={() => onChange(c)} aria-label={`Use ${c}`} data-testid={`brand-color-${c.slice(1).toLowerCase()}`}
        className="flex h-11 w-11 items-center justify-center rounded-full ring-offset-2 transition-transform active:scale-90"
        style={{ background: c, boxShadow: value.toLowerCase() === c.toLowerCase() ? `0 0 0 3px white, 0 0 0 5px ${c}` : "none" }}>
        {value.toLowerCase() === c.toLowerCase() && <Check className="h-5 w-5 text-white" />}
      </button>
    ))}
    <label className="flex h-11 items-center gap-2 rounded-full border-2 border-border bg-card pl-1.5 pr-3 text-sm font-semibold text-foreground">
      <input type="color" value={value} onChange={(e) => onChange(e.target.value.toUpperCase())} data-testid="brand-color-custom-input"
        className="h-8 w-8 cursor-pointer rounded-full border-0 bg-transparent p-0" />
      {value.toUpperCase()}
    </label>
  </div>
);
